import React from "react";
import MuiTable from "../admin/board/components/BoardTable/MuiTable";
import { mapWatchingTableRows } from "./utils/watchingUtils";

export const ListViewTable = ({ projects = [], getCradStatus, columns }) => {
  const rows = React.useMemo(
    () => mapWatchingTableRows(projects, getCradStatus),
    [getCradStatus, projects]
  );

  return (
    <MuiTable
      subHeight={"210"}
      initialRows={rows}
      columns={columns}
      scrollHeight={"calc(96vh - 170px)"}
    />
  );
};
